
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    indentsHeight: { type: Number, default: 80 },
  },
});
